import { Paths } from "../../../router/paths";

/** Link lists and FAQ keys for the screener's SEO section. */
export const SCREENER_FAQ_KEYS = ["q1", "q2", "q3", "q4", "q5"] as const;

export const SCREENER_QUICK_LINKS = [
  { key: "topHalal", path: Paths.TOP_HALAL_STOCKS },
  { key: "stockAnalyses", path: Paths.STOCK_ANALYSES },
  { key: "readyMade", path: Paths.READY_MADE_PORTFOLIO },
  { key: "methodology", path: Paths.SHARIAH_SCREENING_METHODOLOGY },
  { key: "forBusiness", path: Paths.FOR_BUSINESS },
  { key: "academy", path: Paths.ACADEMY },
] as const;

export const SCREENER_POPULAR_SYMBOLS = [
  "NVDA",
  "AAPL",
  "GOOGL",
  "MSFT",
  "AMZN",
  "TSLA",
  "META",
  "AVGO",
] as const;
